<script>
  /* Executable code section of the program */
  //Tools importation
  import { navigate } from "svelte-routing";
  import { auth } from "../apis/APIS";
  import {isProtectedRoute} from "../apis/storage"
  import { onAuthStateChanged } from "firebase/auth";
  //Components importation
  import Loader from "../components/Loader.svelte";
  import { onMount } from "svelte";

  //Auxiliary Variables
  let isLoadedContent = false;

  
    //Logged-in session verification
  onMount(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
		$isProtectedRoute = true;
      } else { 
		navigate("/")
      }
    });
    // Temporizador del loader
    setTimeout(() => (isLoadedContent = true), 1500);
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
 {#if $isProtectedRoute}
 {#if isLoadedContent}
 <section class="errorContainer">
   <div class="contentContainer">
     <h1>No Results Found</h1>
     <p>
       The page you requested could not be found. Try refining your search, or
       use the navigation above to locate the post.
     </p>
     <button class="actionBtn" on:click={() => navigate("/home")}>Go Home</button
     >
   </div>
 </section>
     {:else}
     <Loader/>
 {/if}
 
 {/if}
<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .errorContainer {
    width: 100%;
    height: 40vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px;
    background-color: #f4f4f4;
  }
  .contentContainer {
    width: auto;
    height: auto;
    padding: 20px;
  }
  .actionBtn {
    background-color: white;
    width: 200px;
    height: 50px;
    font-size: 15px;
    font-weight: 500;
    padding: 5px 10px;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }

  /* End of the section */
</style>
